/* eslint-disable complexity */
import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import CloseButton from "../../shared/icon-cross";
import Button from "../../shared/button";
import checkIcon from "./images/check.svg";
import { NUMBER } from "../../../constants/app-constants";

const LoginStepThreeEmailMobile = ({
    onViewDealer,
    dealerName,
    leadGenConfig = {},
    nonLogin = false,
    onClose,
    isComingSoonFlow = false
}) => {
    const [countdown, setCountdown] = useState(NUMBER.FIVE);
    const intervalRef = useRef(null);

    const heading = leadGenConfig?.successScreen?.heading;
    const subHeadingTemplate = leadGenConfig?.successScreen?.subHeading;
    const ctaLabel = leadGenConfig?.successScreen?.cta;
    const successImage = leadGenConfig?.successScreen?.checkDesktop || leadGenConfig?.successScreen?.successImage || checkIcon;

    const subHeading = subHeadingTemplate.replace("{dealerName}", dealerName || "dealership");

    const formContainerStyleName = nonLogin ? "styles.formContainerNonLogin" : "styles.formContainer";

    useEffect(() => {
        if (isComingSoonFlow) {
            intervalRef.current = window.setTimeout(() => {
                if (onClose) {
                    onClose();
                }
            }, NUMBER.THREE_THOUSAND);

            return () => window.clearTimeout(intervalRef.current);
        }

        intervalRef.current = window.setInterval(() => {
            setCountdown((prev) => {
                const next = prev - 1;
                if (next <= 0) {
                    window.clearInterval(intervalRef.current);
                    if (onViewDealer) {
                        onViewDealer();
                    }
                }
                return next;
            });
        }, NUMBER.THOUSAND);

        return () => {
            if (intervalRef.current) {
                window.clearInterval(intervalRef.current);
            }
        };
    }, [isComingSoonFlow, onClose, onViewDealer]);

    const handleViewDealer = () => {
        if (intervalRef.current) {
            window.clearInterval(intervalRef.current);
        }
        if (onViewDealer) {
            onViewDealer();
        }
    };

    const buttonLabel = ctaLabel ? ctaLabel.replace("${countdown}", countdown) : `Redirecting to dealer's page in ${countdown} s`;

    return (
        <div styleName={formContainerStyleName}>
            {onClose && !isComingSoonFlow && (
                <span styleName={"styles.closeIcon"} onClick={onClose}>
                    <CloseButton onClickHandler={onClose} type="grey" />
                </span>
            )}
            <div styleName={"styles.successContent"}>
                <div styleName="styles.mainContent">
                    <div styleName={"styles.iconContainer"}>
                        <img src={successImage} alt="Success" styleName={"styles.successIcon"} />
                    </div>

                    <div styleName={"styles.header"}>
                        {heading}
                    </div>

                    <div styleName={"styles.subHeading"}>
                        {subHeading}
                    </div>
                </div>
                {!isComingSoonFlow && (
                    <div styleName={"styles.footer"}>
                        <Button
                            text={buttonLabel}
                            onClick={handleViewDealer}
                            styleName={"styles.viewDealerButton"}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

LoginStepThreeEmailMobile.propTypes = {
    onViewDealer: PropTypes.func,
    dealerName: PropTypes.string,
    leadGenConfig: PropTypes.object,
    nonLogin: PropTypes.bool,
    onClose: PropTypes.func,
    isComingSoonFlow: PropTypes.bool
};

export default LoginStepThreeEmailMobile;
